export default __webpack_public_path__ + "static/button-primary-do-dark-31c0fdcf32a0e6dd5f06c9b23acb1dc425af79b9a2dfdf2b4ab358f1f161232b.png";